import { render, staticRenderFns } from "./AlertaIncidenciaSimultanea.vue?vue&type=template&id=1b9af79e&scoped=true&"
import script from "./AlertaIncidenciaSimultanea.vue?vue&type=script&lang=js&"
export * from "./AlertaIncidenciaSimultanea.vue?vue&type=script&lang=js&"
import style0 from "./AlertaIncidenciaSimultanea.vue?vue&type=style&index=0&id=1b9af79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9af79e",
  null
  
)

export default component.exports